import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map, take } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';
import { FormlySelectOption } from '@ngx-formly/core/select';

@Injectable()
export class PropertyLandTitlePresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    const options$ = this.dataSetupFacade.dataSetup$?.pipe(
      map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.collateralPropertyLandTitles)),
      take(1),
    );

    let options: FormlySelectOption[] = [];
    options$.subscribe(mappedOptions => {
      options = mappedOptions;
    });

    return {
      type: 'button',
      props: {
        label: 'Property Land Title',
        options: options,
      },
    };
  }
}

export function registerPropertyLandTitlePreset(): ConfigOption {
  return { presets: [{ name: 'propertyLandTitle', config: new PropertyLandTitlePresetProvider() }] };
}
